export default __webpack_public_path__ + "static/media/eye-blue.38ad2786.svg";